<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    title,
    hint = '',
    nopad = false,
    children,
    actions,
  }: {
    title: string;
    hint?: string;
    nopad?: boolean;
    children: Snippet;
    actions?: Snippet;
  } = $props();
</script>

<div class="dash-card">
  <div class="dash-card-head">
    <span class="title">{title}</span>
    <span class="head-right">
      {#if hint}<span class="hint">{hint}</span>{/if}
      {#if actions}{@render actions()}{/if}
    </span>
  </div>
  <div class="dash-card-body" class:nopad>{@render children()}</div>
</div>

<style>
  .dash-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .dash-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.7rem 1rem;
    border-bottom: 1px solid #eef2f2;
    background: #f0fdf4;
  }
  .title {
    font-weight: 700;
    color: #166534;
    font-size: 0.85rem;
    letter-spacing: 0.01em;
  }
  .head-right { display: flex; align-items: center; gap: 0.5rem; }
  .hint { color: #6b7280; font-weight: 500; font-size: 0.75rem; }
  .dash-card-body { padding: 1rem; flex: 1; }
  .dash-card-body.nopad { padding: 0; }
</style>
